import { fileErrorMessages } from '@/constants/errorMessages';

/**
 * Convert a file to data url string
 * @param {File} file input file
 * @returns {Promise} data url string
 */
function convertFileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    if (typeof FileReader !== 'function') {
      reject(new Error(fileErrorMessages.FILE_READER_API_NOT_SUPPORTED));
    }

    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = () => {
      reject(new Error(fileErrorMessages.UNEXPECTED_ERROR));
    };

    reader.readAsDataURL(file);
  });
}

export default convertFileToDataUrl;
